/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  ShareLandToken,
  ShareLandTokenInterface,
} from "../ShareLandToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "shareLandMarketAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "collateralPositionAddress",
        type: "address",
      },
    ],
    name: "setExternalDependencies",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "orderBookAddress",
        type: "address",
      },
    ],
    name: "setOrderBook",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "newSymbol",
        type: "string",
      },
    ],
    name: "updateSymbol",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ShareLandTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShareLandTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShareLandToken__factory extends ContractFactory {
  constructor(...args: ShareLandTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      ShareLandToken & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ShareLandToken__factory {
    return super.connect(runner) as ShareLandToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShareLandTokenInterface {
    return new Interface(_abi) as ShareLandTokenInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ShareLandToken {
    return new Contract(address, _abi, runner) as unknown as ShareLandToken;
  }
}
